import React, {useEffect, useState, useContext} from "react";
import '../assets/css/arrangeableList.css';
import {getLocalStorage, postDataWithFetch} from './Utils';
import ApplicationContext from './ApplicationContext';
import SwipeableListItem from "./SwipeableListItem";

const ArrangeableList = ({entryParser, list}) => {
	const [sortedList, setSortedList] = useState([]);
	const [dropdownStyle, setDropdownStyle] = useState(["none"]);
	const [statusText, setStatusText] = useState("");
	const data = useContext(ApplicationContext);

	useEffect(() => {
		if (list) {
			// console.log("DEBUG:  ArrangeableList - list = ", list);
			setSortedList(list);
			setDropdownStyle(new Array(list.length).fill("none"))
		}
	}, [list]);

	const saveSearckLookupEntries = async(oldEntry, newEntry) => {
		if (data.BASE_URL && oldEntry) {
			const url = `${data.BASE_URL}index.php/search_lookup/update_search_lookup_list`;
			const parms = {OLD_ENTRY: JSON.stringify(oldEntry), NEW_ENTRY:JSON.stringify(newEntry), CATEGORY: getLocalStorage('CATEGORY')};
			// console.log('DEBUG:  ArrangeableList - ', url);
			// console.log('DEBUG:  ArrangeableList - ', parms);
			const json = await postDataWithFetch(url, parms);
			setStatusText(`Saved ${JSON.stringify(json)} records.`);
			// console.log('DEBUG:  output of update_search_lookup_list - ', typeof json, json);
		}
	};

	const saveSearckLookupOrdinals = async(keywordList) => {
		if (data.BASE_URL && keywordList) {
			const url = `${data.BASE_URL}index.php/search_lookup/update_keyword_ordinals`;
			const parms = {KEYWORD_LIST:JSON.stringify(keywordList)};
			// console.log('DEBUG:  ArrangeableList - ', url);
			// console.log('DEBUG:  ArrangeableList - ', parms);
			const json = await postDataWithFetch(url, parms);
			setStatusText(`Saved ${json} records.`);
			// console.log('DEBUG:  output of update_search_lookup_list - ', typeof json, json);
		}
	};

	// add a new entry at the end of the list.
	const newLine = () => {
		// console.log('DEBUG', sortedList);
		let tempList = [...sortedList];
		tempList.push({KEYWORD_SEARCH: '', TICKER_ONLY: '0', foregroundColor: '#000', backgroundColor: '#fff', enabled: '1', new: '1', added: true, monetized: '0' });
		// console.log('DEBUG', tempList);
		setSortedList(tempList);
	};
	
	const saveNewEntries = async() => {
		// console.log('DEBUG:  ArrangeableList - Entering saveNewEntries');
		const url = `${data.BASE_URL}index.php/search_lookup/insert_search_lookup`;
		const parms = {
			NEW_SEARCH_LIST: JSON.stringify({ ...sortedList.filter(e => e.added && e.KEYWORD_SEARCH !== '') }), 
			CATEGORY: getLocalStorage('CATEGORY')
		};

		// console.log('DEBUG:  ArrangeableList - ', url);
		// console.log('DEBUG:  ArrangeableList - ', parms);
		const json = await postDataWithFetch(url, parms);
		// console.log('DEBUG:  output of insert_search_lookup - ', typeof json, json);
		setStatusText(`Saved ${json} records.`);

		// TODO now re-save the list without the added flags
		setSortedList(sortedList.map(({ added, ...rest }) => rest));
	};

	const moveToTop = (index, e) => {
		const newItems = [...sortedList];
		// console.log("DEBUG: ArrangeableList - before newItems = ", newItems);
		const [movedItem] = newItems.splice(index, 1);
		newItems.unshift(movedItem);
		// console.log("DEBUG: ArrangeableList - after newItems = ", JSON.stringify(newItems.map(e => e.KEYWORD_SEARCH)));
		saveSearckLookupOrdinals(newItems.map(e => e.KEYWORD_SEARCH));
		setSortedList(newItems);
		
		const clonedDropdownStyle = [...dropdownStyle];
		clonedDropdownStyle[index] = clonedDropdownStyle[index] === "none" ? "flex" : "none";
		setDropdownStyle(clonedDropdownStyle);
	};

	const moveUp = (index, e) => {
		// console.log("DEBUG:  ArrangeableList - index = ", index, index > 0);
		if (index > 0) {
			const newItems = [...sortedList];
			// console.log("DEBUG: ArrangeableList - before newItems = ", newItems);
			[newItems[index - 1], newItems[index]] = [
				newItems[index],
				newItems[index - 1],
			];
			// console.log("DEBUG: ArrangeableList - after newItems = ", JSON.stringify(newItems.map(e => e.KEYWORD_SEARCH)));
			saveSearckLookupOrdinals(newItems.map(e => e.KEYWORD_SEARCH));

			setSortedList(newItems);
			setDropdownStyle(new Array(newItems.length).fill("none"))
		}
		else {
			const clonedDropdownStyle = [...dropdownStyle];
			clonedDropdownStyle[index] = clonedDropdownStyle[index] === "none" ? "flex" : "none";
			setDropdownStyle(clonedDropdownStyle);
		}
	};

	const moveDown = (index, e) => {
		// console.log("DEBUG:  ArrangeableList - index = ", index, index < sortedList.length - 1);
		if (index < sortedList.length - 1) {
			const newItems = [...sortedList];
			// console.log("DEBUG: ArrangeableList - before newItems = ", newItems.map(e => e.KEYWORD_SEARCH));
			[newItems[index], newItems[index + 1]] = [
				newItems[index + 1],
				newItems[index],
			];
			// console.log("DEBUG: ArrangeableList - after newItems = ", JSON.stringify(newItems.map(e => e.KEYWORD_SEARCH)));
			saveSearckLookupOrdinals(newItems.map(e => e.KEYWORD_SEARCH));
			setSortedList(newItems);
			setDropdownStyle(new Array(newItems.length).fill("none"))
		}
		else {
			const clonedDropdownStyle = [...dropdownStyle];
			clonedDropdownStyle[index] = clonedDropdownStyle[index] === "none" ? "flex" : "none";
			setDropdownStyle(clonedDropdownStyle);
		}
	};

	const moveDown10 = (index, e) => {
		const newIndex = Math.min(index + 10, sortedList.length - 1);
		const newItems = [...sortedList];
		// console.log("DEBUG: ArrangeableList - before newItems = ", newItems.map(e => e.KEYWORD_SEARCH));
		const [movedItem] = newItems.splice(index, 1);
		newItems.splice(newIndex, 0, movedItem);
		// console.log("DEBUG: ArrangeableList - after newItems = ", JSON.stringify(newItems.map(e => e.KEYWORD_SEARCH)));
		saveSearckLookupOrdinals(newItems.map(e => e.KEYWORD_SEARCH));
		setSortedList(newItems);

		const clonedDropdownStyle = [...dropdownStyle];
		clonedDropdownStyle[index] = clonedDropdownStyle[index] === "none" ? "flex" : "none";
		setDropdownStyle(clonedDropdownStyle);
	};

	const moveToBottom = (index, e) => {
		const newItems = [...sortedList];
		// console.log("DEBUG: ArrangeableList - before newItems = ", newItems);
		const [movedItem] = newItems.splice(index, 1);
		newItems.push(movedItem);
		// console.log("DEBUG: ArrangeableList - after newItems = ", JSON.stringify(newItems.map(e => e.KEYWORD_SEARCH)));
		saveSearckLookupOrdinals(newItems.map(e => e.KEYWORD_SEARCH));
		setSortedList(newItems);

		const clonedDropdownStyle = [...dropdownStyle];
		clonedDropdownStyle[index] = clonedDropdownStyle[index] === "none" ? "flex" : "none";
		setDropdownStyle(clonedDropdownStyle);
	};

	// log changes in current input field
	const handleChange = (event, entry) => {
		event.preventDefault();

		// console.log('DEBUG:  event.target.id', event.target.id);
		// console.log('DEBUG:  event.target.value = ', event.target.value);
		// console.log('DEBUG:  entry = ', entry);

		// create new list where everything stays the same except that the current
		// item replaces the existing value at this index
		let found;
		const list = sortedList.map((item, i, arr) => {
			if (i !== Number(event.target.id)) {
				return item;
			}
			else {
				found = arr[i];
				found.KEYWORD_SEARCH = event.target.value;
				return found;
			};
		});

		// console.log("DEBUG:  list = ", list);
		setSortedList(list);

		// console.log("DEBUG:  calling saveSearckLookupEntries on ", entry, found);
		saveSearckLookupEntries(entry, found);
	};

	return (
		<div className="list-container">
			<ul id="sortable-list">
				{sortedList.map((item, i, arr) => {
					let res = entryParser(item);
					// console.log("DEBUG", "Rendering res", res);
					// console.log("DEBUG", "Rendering item", item);
					// console.log("DEBUG", "Rendering item.enabled", i, item.enabled);
					// console.log("DEBUG", "Rendering item.foregroundColor", item.foregroundColor);
					if (typeof res?.KEYWORD_SEARCH === 'string' && res?.backgroundColor && res?.foregroundColor) {
						return (
							<SwipeableListItem key={i} index={i} entry={res} arr={arr} 
								rightSideActions={{moveToTop, moveUp, moveDown, moveDown10, moveToBottom}}
								saveSearckLookupEntries={saveSearckLookupEntries}
								setSortedList={setSortedList}>
								<input id={i} className="color-input" draggable="false"
									style={{
										backgroundColor: res.backgroundColor,
										color: res.foregroundColor
									}}
									type="text" 
									placeholder="Enter New Category" 
									onChange={(e) => handleChange(e, res)}
									value={res.KEYWORD_SEARCH} 
								/>
							</SwipeableListItem>
						);
					}
					else {
						return (
							<li key={i} id={i} className="input-container"></li>
						)
					}
				})}
			</ul>
			<div className="btn-container">
				<button className="my-button" style={{background: "#2500ccff", color: "#fff"}} onClick={() => newLine()}>ADD</button>
				<button className="my-button" style={{background: "#00cc30ff", color: "#fff"}} onClick={saveNewEntries}>SAVE</button>
			</div>
			<div className="status-text" style={{display: statusText?.length ? 'block' : 'none'}}>
				<p className="paragraph-status-text">{statusText}</p>
			</div>
		</div>
	);
};

export default ArrangeableList;
